import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';

import HomepageArchitizerJournal from '../components/homepage/HomepageArchitizerJournal';

ReactDOM.render(
  <HomepageArchitizerJournal />,
  document.getElementById('ArchitizerJournal'),
);



// WEBPACK FOOTER //
// ./js/src/views/HomepageArchitizerJournal.jsx